import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

const TextLabel = styled.b`
  color: ${themeGet('colors.medium')};
  display: block;
  font-family: ${themeGet('fonts.heading')};
  font-size: ${themeGet('fontSizes.xxs')};
  letter-spacing: 0.0625rem;
  text-transform: uppercase;
`

export default TextLabel
